module.exports = __webpack_public_path__ + "static/hire-dash-7fcb6d3a81a5c58c5ab79a488f7550bd.svg";